<template>
    <div class="text-center">
      
    </div>
</template>

<script>
export default {
    name:'FailedPayment',
    mounted(){
            Swal.fire(
                "Paiement error !",
                "Votre paiement n'a pas pu être effectué, veuillez réessayer plus tard.",
                'error'
            )
    }
}
</script>